import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-immobiliare-view',
  templateUrl: './form-immobiliare-view.component.html',
  styleUrls: ['./form-immobiliare-view.component.css']
})
export class FormImmobiliareViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
